/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Design_Settings_Primary_DescInputs */

const en_admin_design_settings_primary_desc = /** @type {(inputs: Admin_Design_Settings_Primary_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Used for buttons, links and highlights.`)
};

const de_admin_design_settings_primary_desc = /** @type {(inputs: Admin_Design_Settings_Primary_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird für Buttons, Links und Hervorhebungen verwendet.`)
};

/**
* | output |
* | --- |
* | "Used for buttons, links and highlights." |
*
* @param {Admin_Design_Settings_Primary_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_design_settings_primary_desc = /** @type {((inputs?: Admin_Design_Settings_Primary_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Design_Settings_Primary_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_design_settings_primary_desc(inputs)
	return en_admin_design_settings_primary_desc(inputs)
});